module.exports = __webpack_public_path__ + "static/img/join-bg-2.3a18612e.png";